import { calculatePlaceholderPosition } from './calculatePlaceholderPosition';
export function createHoverHandler(config, state = {
  lastProcessedPosition: null,
  lastMousePosition: null,
  dragDirection: null
}) {
  const hasMouseMovedEnough = (currentPosition, lastPosition, threshold = 10) => {
    if (!lastPosition) return true;
    const deltaX = Math.abs(currentPosition.x - lastPosition.x);
    const deltaY = Math.abs(currentPosition.y - lastPosition.y);
    return deltaX >= threshold || deltaY >= threshold;
  };
  const calculateDragDirection = (currentPosition, lastPosition, orientation, threshold = 5) => {
    if (!lastPosition) return null;
    const delta = orientation === 'horizontal' ? currentPosition.x - lastPosition.x : currentPosition.y - lastPosition.y;
    if (Math.abs(delta) > threshold) {
      return delta > 0 ? 'increasing' : 'decreasing';
    }
    return null;
  };
  return mousePosition => {
    const currentPosition = {
      x: mousePosition.x,
      y: mousePosition.y
    };

    // Skip if mouse hasn't moved enough
    if (!hasMouseMovedEnough(currentPosition, state.lastProcessedPosition)) {
      return;
    }
    state.lastProcessedPosition = currentPosition;

    // Calculate drag direction locally
    const newDirection = calculateDragDirection(currentPosition, state.lastMousePosition, config.getOrientation());
    if (newDirection) {
      state.dragDirection = newDirection;
    }
    state.lastMousePosition = currentPosition;
    const fromIndex = config.getFromIndex();
    if (fromIndex === null || fromIndex === config.hoveredIndex) {
      return;
    }
    const element = config.getElement();
    if (!element) {
      return;
    }
    const currentToIndex = config.getCurrentToIndex();
    const newToIndex = calculatePlaceholderPosition({
      currentToIndex,
      dragDirection: state.dragDirection,
      hoveredIndex: config.hoveredIndex,
      hoveredElement: element,
      mouseX: mousePosition.x
    });
    const updates = {
      mousePosition
    };
    if (newToIndex !== currentToIndex) {
      updates.dropTarget = newToIndex;
    }
    config.updateDragState(updates);
  };
}